import React, { useContext } from 'react';

import { Link, rem, BoxProps, useBreakpointValue } from '@vimeo/bokeh';
import { VimeoV_iris } from '@vimeo/bokeh-icons';
import { translate } from '@vimeo/i18n-runtime';
import Logo from '@vimeo/ui/core/Logo';
import VideoJi from '@vimeo/ui/core/VideoJi';
import { ViewerContext } from '@vimeo/viewer';

import { useTrackNavigationEvent } from '../../tracking';

/**
 * Display the Vimeo logo for use in the navigation bar.
 * A different logo is used at mobile sizes.
 * Is simplified site - will display the VideoJi logo
 */
export const VimeoLogo = ({ display = 'flex' }: Pick<BoxProps, 'display'>) => {
  const viewer = useContext(ViewerContext);
  const isSimplifiedSite = viewer?.isSimplifiedSite;
  const goToVimeoHomepage = isSimplifiedSite
    ? translate('Go to Videoji home page')
    : translate('Go to Vimeo home page');

  const logo = useBreakpointValue({
    base: <VimeoV_iris boxSize="xs" color="text-primary" />,
    md: <Logo color="text-primary" width={rem(78)} />,
  });

  // Disable the link if the user is not logged in and the site is simplified
  const disableLink = !viewer?.user && isSimplifiedSite;
  const logoHref = disableLink ? 'javascript:void(0);' : '/';
  const trackNavigationEvent = useTrackNavigationEvent();

  return typeof isSimplifiedSite === 'undefined' ? (
    <></>
  ) : (
    <Link
      href={logoHref}
      onClick={() =>
        trackNavigationEvent({ feature: 'general', copy: 'vimeo_logo', element: 'button' })
      }
      id="header-vimeo-logo"
      title={goToVimeoHomepage}
      maxWidth="max-content"
      display={display}
      variant="secondary"
    >
      {isSimplifiedSite ? <VideoJi data-testid="videoji-logo" /> : logo}
    </Link>
  );
};
